(function () {
  'use strict';

  var isBound = false;

  function onConfirmedCartUpdate(event) {
    if (!event || !event.source) return;

    if (event.source === 'product-form') {
      window.clarity?.('event', 'cart_add_success');
      return;
    }

    if (event.source === 'brilinton-studio') {
      window.clarity?.('event', 'setup_add_success');
    }
  }

  function bindConfirmedCartEvents() {
    if (isBound) return true;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

    subscribe(PUB_SUB_EVENTS.cartUpdate, onConfirmedCartUpdate);
    isBound = true;
    return true;
  }

  if (!bindConfirmedCartEvents()) {
    document.addEventListener('DOMContentLoaded', bindConfirmedCartEvents, { once: true });
  }
})();
